module.exports = __webpack_public_path__ + "img/rtv-parkstad-home-cover.e069edb9.png";